import { useCommon } from "../../composition-functions/common";
import { generateUrlSearchParameters } from "./service.genericTableQuery";
import { EntityFromGenericTableQuery, GenericTableQuery } from "./type.genericTableQuery";
import { GenericTableSchema } from "./type.genericTableSchema";

export const EMPTY_VALUE_PLACEHOLDER = "-" as const;

export type GenericTableDefinition = {
  getPath: (mandantId: number) => `${string}/`;
  schema: GenericTableSchema;
};

type FetchEntitiesParams<T extends GenericTableSchema, S extends GenericTableQuery<T>> = {
  schema: T;
  path: string;
  query: S;
};
type FetchEntitiesReturnType<T extends GenericTableSchema, S extends GenericTableQuery<T>> = Promise<{
  totalItems: number;
  result: EntityFromGenericTableQuery<T, S>[];
}>;

export async function fetchEntities<T extends GenericTableSchema, S extends GenericTableQuery<T>>({
  path,
  query,
}: FetchEntitiesParams<T, S>): FetchEntitiesReturnType<T, S> {
  const { getRequest } = useCommon();
  const params = generateUrlSearchParameters(query);
  const normalizedPath = `${path}`.replace(/\/+$/, "");
  const response = await getRequest({ path: `${normalizedPath}?${params.toString()}` });
  const data = await response.json();
  return data;
}

export async function downloadEntitiesAsCsv<T extends GenericTableSchema, S extends GenericTableQuery<T>>({
  path,
  query,
}: FetchEntitiesParams<T, S>) {
  const { getRequest } = useCommon();
  const params = generateUrlSearchParameters(query);
  const normalizedPath = `${path}`.replace(/\/+$/, "");
  const response = await getRequest({ path: `${normalizedPath}/downloadCsvLink?${params.toString()}` });
  const { downloadLink } = await response.json();

  const link = document.createElement("a");
  link.setAttribute("download", "");
  link.href = downloadLink;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
